/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Sync_Changes_Missing_Group_ErrorInputs */



/**
* | output |
* | --- |
* | "Linked Event Group not found in project. Linked group id: {id}" |
*
* @param {Sync_Changes_Missing_Group_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_missing_group_error = /** @type {((inputs: Sync_Changes_Missing_Group_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Missing_Group_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Groupe d'evenements lie introuvable dans le projet. ID du groupe lie : ${i?.id}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Verknüpfte Ereignisgruppe im Projekt nicht gefunden. Gruppen-ID: ${i?.id}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Gruppo di eventi collegati non trovato nel progetto. ID gruppo collegato: ${i?.id}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Связанная группа событий не найдена в проекте. Идентификатор связанной группы: ${i?.id}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se encontró el grupo de eventos vinculados en el proyecto. ID del grupo vinculado: ${i?.id}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`项目中未找到关联事件组。关联组 ID：${i?.id}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プロジェクト内にリンクされたイベントグループが見つかりません。リンクされたグループID: ${i?.id}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रोजेक्ट में लिंक्ड इवेंट ग्रुप नहीं मिला। लिंक्ड ग्रुप आईडी: ${i?.id}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Grupo de eventos vinculados não encontrado no projeto. ID do grupo vinculado: ${i?.id}`)
	return /** @type {LocalizedString} */ (`Linked Event Group not found in project. Linked group id: ${i?.id}`)
});